/* expand_collapse.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="-227 229 24 24" preserveAspectRatio="none">
            <path class="foreground-gl" d="M-224.2,233.6l9.2,9.2l9.2-9.2l2.8,2.8l-12,12l-12-12L-224.2,233.6z"></path>
        </svg>
    `,
};
